export { default } from "ember-file-upload/components/file-dropzone";
